import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10509c7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-0 wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "col-sm-auto image-container"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-flex flex-column col-sm g-0" }
const _hoisted_5 = { class: "content-container" }
const _hoisted_6 = { class: "px-2" }
const _hoisted_7 = { class: "entry-content pt-2 my-auto" }
const _hoisted_8 = { class: "mt-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialSharing = _resolveComponent("SocialSharing")!
  const _component_attribute_list = _resolveComponent("attribute-list")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return ($props.thought)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["wdw-news-thought-in-list mb-2 container-fluid g-0", 'thought-' + $props.thought.id])
      }, [
        _createElementVNode("div", _hoisted_1, [
          ($props.thought.files[0])
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.openSingleThought && $setup.openSingleThought(...args)))
                }, [
                  _createElementVNode("img", {
                    class: "entry-image",
                    style: _normalizeStyle($setup.imgStyle),
                    src: $props.thought.files[0].url
                  }, null, 12, _hoisted_3)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(_component_SocialSharing, {
                  url: $setup.getCurrenThoughtUri($props.thought.id),
                  title: $props.thought.title,
                  description: $props.thought.content
                }, null, 8, ["url", "title", "description"]),
                _createElementVNode("a", {
                  class: "entry-title",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.openSingleThought && $setup.openSingleThought(...args)))
                }, [
                  _withDirectives(_createElementVNode("h5", null, null, 512), [
                    [_directive_dompurify_html, $props.thought.title]
                  ])
                ]),
                ($props.thought.attributes)
                  ? (_openBlock(), _createBlock(_component_attribute_list, {
                      key: 0,
                      attributes: $props.thought.attributes
                    }, null, 8, ["attributes"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_font_awesome_icon, { icon: "calendar-days" }),
                _createElementVNode("span", _hoisted_6, _toDisplayString($setup.formattedDate($props.thought.publication_date, true)), 1)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                [_directive_dompurify_html, $setup.getPlainText($props.thought.content, ['figcaption'])]
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.openSingleThought && $setup.openSingleThought(...args))),
                  class: "btn btn-primary mt-2"
                }, "weiterlesen")
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}